import { useEffect, useRef, useState } from 'react';
import logo from '../../Images/logo.svg';
import logo_dark from '../../Images/logo_white.webp';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    Close,
    Search,
    Menu,
} from "@mui/icons-material";

const data = [
    { name: 'home', link: '/' },
    { name: 'laws_codes', link: '/laws-codes/laws' },
    { name: 'about', link: '/about' },
    { name: 'services', link: '/online-service' },
    { name: 'news', link: '/news/table' },
    { name: 'faq', link: '/faq' },
    { name: 'contacts', link: '/map' },
];

const Categories = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [isBlurActive, setIsBlurActive] = useState(false);
    const [scrolling, setScrolling] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const sidebarRef = useRef(null);

    // const toggleMobileMenu = () => {
    //     setIsMobileMenuOpen(!isMobileMenuOpen);
    //     setIsBlurActive(!isMobileMenuOpen);
    // };

    const handleCloseMenu = () => {
        setIsMobileMenuOpen(false);
        setIsBlurActive(false);
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        document.addEventListener("mousedown", handleClickOutside);
        return function cleanup() {
            document.removeEventListener("scroll", handleScroll);
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 140) {
            setScrolling(true);
        } else {
            setScrolling(false);
        }
    };

    const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <>
            <div
                className="mt-2 xxl:px-12 xxxl:px-32 xxxxl:px-64
                           xxxxxl:px-[400px] xxxxxxl:px-[650px]
                           xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]"
            >
                <div className="flex gap-16 justify-between items-center">
                    <div
                        className={`flex justify-between w-full xl:w-max
                        ${scrolling ? 'fixed xl:hidden top-0 py-2 z-30 px-4 bg-primary dark:bg-dark-box transition-all ease-in-out duration-500'
                                : ''}`}
                    >
                        <Link to='/'>
                            <div className="flex gap-2 items-center">
                                <img
                                    src={scrolling ? logo_dark : logo}
                                    alt="logo"
                                    decoding="async"
                                    data-nimg="1"
                                    loading="lazy"
                                    className={`h-12 xl:h-20 ${scrolling ? 'pl-0'
                                        : 'pl-4 xxl:pl-0'}`}
                                />
                                {scrolling ? '' :
                                    <h1 className="font-bold text-green text-sm xl:text-xl">
                                        {t('supreme_court')} <br />
                                        {t('turkmenistan')}
                                    </h1>
                                }
                            </div>
                        </Link>
                        <button className={`xl:hidden text-white dark:text-dark-text
                                            ${scrolling ? '' : 'absolute right-0 pr-4 pt-[6px]'}`}
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        >
                            <Menu style={{ fontSize: '28px' }} />
                        </button>
                    </div>

                    {/* Scroll for desktop */}
                    <div className={scrolling ?
                        'fixed xl:py-2 top-0 w-full left-0 shadow-sm z-30 bg-primary transition-all ease-in-out duration-500 dark:bg-dark-box text-white px-4 xxl:px-12  xxxl:px-32 xxxxl:px-64 xxxxxl:px-[400px] xxxxxxl:px-[650px] xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]' :
                        'text-white max-w-[78%] xl:pr-4 xxl:pr-0'}
                    >
                        <section className='hidden xl:flex w-full justify-between font-bold
                                            items-center xl:text-[15px]'>
                            <Link to='/'>
                                <div className={scrolling ? 'block' : "hidden"}>
                                    <img
                                        src={logo_dark}
                                        alt="logo" 
                                        className='w-10 mr-4'
                                        loading="lazy"
                                    />
                                </div>
                            </Link>
                            <ul className='flex gap-3 items-center'>
                                {data.map((d, id) => (
                                    <Link
                                        to={d.link}
                                        key={id}
                                        className={`relative group  ${scrolling ? 'text-white' :
                                            (location.pathname === d.link ?
                                                'border-b-2 border-b-primary' : '')}`}
                                    >
                                        <li className={`relative after:content-['']
                                                     after:absolute after:left-0 after:bottom-0 
                                                     after:h-[2px] pb-1 pt-1
                                                     ${location.pathname === d.link ? 'after:w-0' : 'after:w-0'}
                                                     ${scrolling ? 'after:bg-white' : 'after:bg-primary'}
                                                     after:transition-all after:duration-500 
                                                     group-hover:after:w-full 
                                                     ${scrolling ? 'group-hover:text-white'
                                                : 'group-hover:text-blue'} 
                                                     `}
                                        >
                                            {t(d.name)}
                                        </li>
                                    </Link>
                                ))}
                                <li className='hover:border-b-2 
                                               hover:border-b-primary'>
                                    <Link to='/search' className='flex items-center gap-1'>
                                        <Search style={{ fontSize: '20px', marginTop: '1px' }} />
                                    </Link>
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>

            {/* Mobile sidebar */}
            <div
                ref={sidebarRef}
                className={`xl:hidden fixed right-0 top-0 w-[80%] h-full 
                      bg-white dark:bg-dark z-40 p-4 transform 
                      transition-transform duration-300 ease-in-out 
                      ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
                    }`}
            >
                <div className="flex justify-end">
                    <button onClick={() => {
                        setIsMobileMenuOpen(false);
                        handleCloseMenu()
                    }}
                    >
                        <Close className="text-primary dark:text-dark-text" />
                    </button>
                </div>
                <Link
                    to='/search'
                    className='flex items-center gap-1 mt-8'
                >
                    <Search className="text-primary dark:text-dark-text" />
                    <p className='text-primary dark:text-dark-text'>
                        {t('search')}
                    </p>
                </Link>
                <ul className="mt-8 space-y-4 text-black dark:text-dark-text">
                    {data.map((d, id) => (
                        <Link
                            to={d.link}
                            key={id}
                        >
                            <li className='hover:text-primary border-b border-b-secondary
                                           dark:border-b-dark-border py-2'>
                                {t(d.name)}
                            </li>
                        </Link>
                    ))}
                </ul>
            </div>
            {
                isBlurActive && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-30 
                                   backdrop-filter backdrop-blur-sm z-10"
                        onClick={handleCloseMenu}
                    ></div>
                )
            }
        </>
    );
};

export default Categories;
